import { createAsyncThunk } from "@reduxjs/toolkit"

import { handleApiError } from "../../../../Utils/thunkHelpers"
import * as services from "../services"
import { REQUESTS_VERIFI_INFORM_SLICE_NAME } from "./requestsVerifiInform.constants"

export const getRequestsVerifiInform = createAsyncThunk(
  `${REQUESTS_VERIFI_INFORM_SLICE_NAME}/get_requests_verifi_inform`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getRequestsVerifiInform(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getRequestVerifiInform = createAsyncThunk(
  `${REQUESTS_VERIFI_INFORM_SLICE_NAME}/get_request_verifi_inform`,
  async ({ id }, { dispatch, rejectWithValue }) => {
    const response = await services.getRequestVerifiInform({ id })
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const updateRequestVerifiInformStatus = createAsyncThunk(
  `${REQUESTS_VERIFI_INFORM_SLICE_NAME}/update_request_verifi_inform_status`,
  async (params, { rejectWithValue }) => {
    try {
      const response = await services.updateRequestVerifiInformStatus(params)
      if (!response?.ok) {
        return rejectWithValue({ message: "Failed to update status" })
      }
      return { ...params, response }
    } catch {
      return rejectWithValue({ message: "Failed to update status" })
    }
  }
)
